import React, { FC } from 'react';
import { Box } from '@material-ui/core';
import CustomButton from '../../common/components/CustomButton';

interface Params {
  handleCancel?(): void;
  handleConfirm?(): void;
  cancelText?: string;
  confirmText?: string;
  confirmLoadingText?: string;
  disableCancel?: boolean;
  disableConfirm?: boolean;
  confirmLoading?: boolean;
  containerStyle?: React.CSSProperties;
  cancelStyle?: React.CSSProperties;
  confirmStyle?: React.CSSProperties;
}

const ConfirmationButtons: FC<Params> = (props) => {
  const {
    handleCancel,
    handleConfirm,
    disableCancel,
    disableConfirm,
    cancelText,
    confirmText,
    confirmLoadingText,
    confirmLoading,
    containerStyle,
    cancelStyle,
    confirmStyle,
  } = props;

  return (
    <Box
      style={{
        display: 'flex',
        justifyContent: 'center',
        ...containerStyle,
      }}>
      <CustomButton
        onClick={handleCancel}
        style={cancelStyle}
        disabled={disableCancel}>
        {cancelText || 'Annuler'}
      </CustomButton>
      <CustomButton
        color="secondary"
        onClick={handleConfirm}
        style={{ marginLeft: 8, ...confirmStyle }}
        disabled={disableConfirm}>
        {confirmLoading
          ? confirmLoadingText ?? 'Chargement...'
          : confirmText ?? 'Confirmer'}
      </CustomButton>
    </Box>
  );
};

export default ConfirmationButtons;
